module.exports = __webpack_public_path__ + "img/botabib_logo.c16fec60.svg";